module.exports = __webpack_public_path__ + "img/comiru_recorder.4c11a06b.jpg";